export default __webpack_public_path__ + "static/media/light_mode.faa5054f.svg";